import { computed } from 'vue'
import { useApiClient, useQuery } from '@fusapp-work/shell'
import { createPersonnelApi } from './domain/personnel'
import { useConsolePrincipal } from './useConsolePrincipal'

/** The server resolves verified issuer+oid. Session sub/email are never projection IDs. */
export function useCurrentPersonnel() {
  const principal = useConsolePrincipal(); const api = createPersonnelApi(useApiClient())
  return useQuery({ queryKey: computed(() => ['console', principal.value, 'current-personnel']), queryFn: ({ signal }) => api.me(signal), enabled: computed(() => Boolean(principal.value)), retry: false })
}
